import React from "react";
import { CheckCircleIcon } from "@heroicons/react/solid";
import Link from "next/link";

/*
    SuccessBlockMessage component: Appears to provide an outcome once the user has attempted an action
    Takes the following props:
        - successState: The error message to be shown in the block message
        - redirectLink: The link to redirect to after the block message is closed
*/
export default function SuccessBlockMessage(props) {
  // if the error message is empty, return nothing
  if (props.successState) {
    return (
      <>
        <div className="rounded-md bg-green-50 p-4">
          <div className="flex">
            <div className="flex-shrink-0">
              <CheckCircleIcon
                className="h-5 w-5 text-green-400"
                aria-hidden="true"
              />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-green-900">
                {props.successState}
              </h3>
              <div className="mt-2 text-sm text-green-700">
                <p>
                  Please check your email for a link to reset your password. It
                  may be in your spam folder.
                  <br />
                  Following that, you may return to sign in to your account.
                </p>
              </div>
              <div className="mt-4">
                <div className="-mx-2 -my-1.5 flex">
                  <Link href={props.redirectLink} legacyBehavior>
                    <button
                      type="button"
                      className="rounded-md bg-green-50 px-2 py-1.5 text-sm font-medium text-green-800 hover:bg-green-100 focus:outline-none focus:ring-2 focus:ring-green-600 focus:ring-offset-2 focus:ring-offset-green-50"
                    >
                      Return to sign in page
                    </button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  } else {
    return null;
  }
}
